import React from "react";
import TopoTexture from "@/components/TopoTexture";
import { CheckCircle2, Users, Wrench, MapPinned, Clock4 } from "lucide-react";
import { COMPANY, IMG } from "@/data/site";

const reasons = [
  { icon: <CheckCircle2 className="w-6 h-6" />, title: `${COMPANY.yearsInBusiness}+ Years of Experience`, text: "Serving Wyoming since 1980 — trusted through generations of Casper families and businesses." },
  { icon: <Users className="w-6 h-6" />, title: "Trained & Vetted Movers", text: "Background-checked, experienced crews who treat every home with respect and care." },
  { icon: <Wrench className="w-6 h-6" />, title: "Professional Equipment", text: "Full pads, dollies, ramps, and floor protection — proper tools for a flawless move." },
  { icon: <MapPinned className="w-6 h-6" />, title: "Local Wyoming Expertise", text: "We know every street in Casper, Mills, Bar Nunn, and beyond — no wasted time." },
  { icon: <Clock4 className="w-6 h-6" />, title: "Open 24 Hours", text: "Flexible scheduling including evenings, weekends, and last-minute or emergency moves." },
];

const WhyChooseUs = () => {
  return (
    <section data-testid="why-choose-section" className="relative py-20 md:py-32 bg-white overflow-hidden">
      <TopoTexture variant="light" />
      <div className="section-container relative">
        <div className="grid lg:grid-cols-12 gap-12 items-start">
          <div className="lg:col-span-5 lg:sticky lg:top-28">
            <div className="label-xs text-[var(--ct-primary)] mb-3">Why Crosstown Movers</div>
            <h2 className="text-3xl sm:text-4xl lg:text-5xl font-semibold text-[var(--ct-primary)] tracking-tight" style={{ fontFamily: "Outfit" }}>
              A local Wyoming moving company you can actually trust.
            </h2>
            <p className="mt-5 text-[var(--ct-text-muted)] leading-relaxed">
              We're a locally owned moving company with deep roots in Casper and Mills WY. For more than {COMPANY.yearsInBusiness} years,
              we've earned 4.5-star reviews by focusing on what matters: careful handling, fair pricing, and
              moving crews you'd be happy to invite into your home.
            </p>
            <div className="mt-8 rounded-3xl overflow-hidden shadow-[0_20px_40px_rgba(0,0,0,0.08)]">
              <img
                src={IMG.wyoming}
                alt="Wyoming mountains - local Crosstown Movers service area"
                className="w-full h-[280px] object-cover"
              />
            </div>
          </div>

          <div className="lg:col-span-7 grid sm:grid-cols-2 gap-5">
            {reasons.map((r, i) => (
              <div
                key={i}
                data-testid={`reason-${i}`}
                className="p-7 rounded-2xl bg-[var(--ct-bg)] border border-[var(--ct-border)] hover:border-[var(--ct-primary)] hover:-translate-y-1 transition-all duration-300"
              >
                <div className="w-12 h-12 rounded-xl bg-[var(--ct-primary)] text-white flex items-center justify-center">
                  {r.icon}
                </div>
                <h3 className="mt-4 text-xl font-semibold text-[var(--ct-primary)]" style={{ fontFamily: "Outfit" }}>
                  {r.title}
                </h3>
                <p className="mt-2 text-sm text-[var(--ct-text-muted)] leading-relaxed">{r.text}</p>
              </div>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
};

export default WhyChooseUs;
